<template>
  <div class="w-full p-3 text-center" :class="classVariant">
    <template v-if="$slots.default">
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  name: 'YesAlert',
  props: {
    variant: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    classVariant () {
      let classVariant = ''
      if (this.variant === 'primary') {
        classVariant = 'bg-light-blue text-premier-blue'
      }
      if (this.variant === 'success') {
        classVariant = 'bg-green-300 text-green-700'
      }
      if (this.variant === 'warning') {
        classVariant = 'bg-warning text-white'
      }
      if (this.variant === 'danger') {
        classVariant = 'bg-red-300 text-danger'
      }
      return classVariant
    }
  }
}
</script>

<style scoped>

</style>
